import style from "./ArticleManagementLayout.module.css";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import { useEffect, useRef, useState } from "react";
import { adminRequester } from "App";
import TableSearchCard from "routes/table/search/TableSearchCard";
import SingleAdminTable from "../table/SingleAdminTable";
import P from "components/P";
import NiceModal from "@ebay/nice-modal-react";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import TableButton from "../table/TableButton";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import clsx from "clsx";
import { t } from "i18next";
import ToolTip from "components/tooltip/tooltip";
import AdminCustomButton from "components/buttons/AdminCustomButton";

export const limit = 20;

function ArticleManagementLayout(props) {
  const [count, setCount] = useState(0);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(0);
  const [searchCondition, setSearchCondition] = useState();
  const { keyword } = useParams();
  const [theader, setTheader] = useState([]);
  const [outs, setOuts] = useState([]);
  const [buttons, setButtons] = useState([]);
  const [reset, setReset] = useState(false);
  const [research, setResearch] = useState(false);
  const [extraCondition, setExtraCondition] = useState({});
  const [views, setViews] = useState([]);
  const [outputHeader, setOutputHeader] = useState([]);
  const researchInterval = useRef();
  const navigate = useNavigate();
  useEffect(() => {
    adminRequester.getArticleStatus(
      {
        ...extraCondition,
        ...searchCondition,
        offset: page * limit,
        limit: limit,
      },
      (result) => {
        setCount(result.count);
        setMaxPage(result.count / limit);
        setData(result.articles);
      }
    );
  }, [page, searchCondition]);
  useEffect(() => {
    if (reset) {
      setData([]);
      setReset(false);
      setMaxPage(0);
      setCount(0);
    }
  }, [reset]);
  useEffect(() => {
    if (research) {
      adminRequester.getArticleStatus(
        {
          ...extraCondition,
          ...searchCondition,
          offset: page * limit,
          limit: limit,
        },
        (result) => {
          setCount(result?.count);
          setMaxPage(result?.count / limit);
          setData(result?.articles);
        }
      );
      setResearch(false);
    }
  }, [research]);
  useEffect(() => {
    let indexes = [];
    let buttons = [];
    switch (keyword) {
      default: {
        // indexes = [0, 1, 2, 3, 4];
        indexes = theaderList?.map((theader, index) => index);
        // const outputHeader = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
        buttons = ["articleDelete"];
        setViews(["AllArticle"]);
        setExtraCondition({});
        setOutputHeader([]);
        // setOutputHeader(outputHeader.map((index) => outputHeaderList[index]));
        break;
      }
    }
    setButtons(
      buttons
        .map((code) => TableButton(code, () => setResearch(true)))
        .filter((button) => !!button)
    );
    setTheader(
      indexes.map((index) => theaderList[index]).filter((theader) => !!theader)
    );
    setReset(true);
  }, [keyword]);
  useEffect(() => {
    if (outputHeader?.length > 0)
      setOuts({
        getData: getOutput(outputHeader),
      });
  }, [outputHeader, extraCondition, searchCondition]);
  const callback = (searchCondition) => {
    setPage(0);
    setSearchCondition(searchCondition);
  };

  const dataCallback = (value) => {
    setData(value);
  };
  const openEdit = ({ row }) => {
    NiceModal.show("articleDetail", {
      data: row,
      onSuccess: () => setResearch(true),
    });
  };
  const onCopy = async (value, message) => {
    await window.navigator.clipboard.writeText(value);
    toast.success(`${message} 복사하였습니다.`, {
      autoClose: 1000,
      position: "bottom-center",
    });
  };

  const theaderList = [
    {
      width: 50,
      text: "No.",
      justifyContent: "flex-start",
      Cell: ({ index }) => index + 1,
      hover: true,
      cursor: true,
      onClick: openEdit,
      index: "0",
    },
    {
      width: 100,
      text: "작성일",
      justifyContent: "flex-start",
      code: "created_at",
      Cell: ({ cell }) => cell.split("T")[0],
      hover: true,
      cursor: true,
      onClick: openEdit,
      index: "1",
    },
    {
      width: 100,
      text: "ID",
      justifyContent: "flex-start",
      ellipsis: true,
      ellipsis_hover: true,
      ellipsis_copy: true,
      code: "id",
      index: "2",
    },
    {
      width: 100,
      text: "종류",
      justifyContent: "flex-start",
      code: "board",
      Cell: ({ cell }) => t(cell?.name),
      hover: true,
      cursor: true,
      onClick: openEdit,
      index: "3",
    },
    {
      width: 300,
      text: "제목",
      justifyContent: "flex-start",
      ellipsis: true,
      code: "title",
      hover: true,
      cursor: true,
      onClick: openEdit,
      index: "4",
    },
    {
      width: 100,
      text: "기간",
      justifyContent: "flex-start",
      Cell: ({ row }) => {
        const start_date = new Date(row.start_date);
        const end_date = new Date(row.end_date);
        const now = new Date();
        const tranferToString = (date) => {
          date = new Date(date);
          return date
            .toISOString()
            .replace("T", " ")
            .slice(0, 16);
        };
        let result;
        if (row.start_date && now < start_date) result = "예정";
        if (
          row.start_date &&
          row.end_date &&
          now >= start_date &&
          now < end_date
        )
          result = "진행중";
        if (row.end_date && now >= end_date) result = "종료";
        return result ? (
          <ToolTip
            style={{
              zindex: 1,
              padding: 5,
              backgroundColor: "white",
              width: "max-content",
            }}
            title={
              <P>{`${tranferToString(row.start_date)} ~ ${tranferToString(
                row.end_date
              )}`}</P>
            }
          >
            <P>{result}</P>
          </ToolTip>
        ) : (
          "무제한"
        );
      },
      index: "5",
    },
    {
      width: 100,
      text: "상태",
      justifyContent: "flex-start",
      ellipsis: true,
      code: "hidden",
      Cell: ({ cell }) => (cell ? "비밀글" : "일반글"),
      hover: true,
      cursor: true,
      onClick: openEdit,
      index: "6",
    },
    {
      width: 200,
      text: "작성자",
      justifyContent: "flex-start",
      Cell: ({ row }) => {
        if (row.user) {
          const user = row.user;
          return (
            <ToolTip
              style={{
                zIndex: 1,
                padding: 10,
                backgroundColor: "white",
                width: "max-content",
                borderWidth: "1px",
                borderColor: "gray",
                borderStyle: "solid",
                borderRadius: 10,
              }}
              title={
                <VerticalFlex>
                  <P>[관리자]</P>
                  <P
                    hover
                    cursor
                    onClick={() =>
                      onCopy(
                        `${user.first_name}${
                          user.last_name ? ` ${user.last_name}` : ""
                        }`,
                        "이름을"
                      )
                    }
                  >{`${user.first_name}${
                    user.last_name ? ` ${user.last_name}` : ""
                  }`}</P>
                  <P hover cursor onClick={() => onCopy(user.id, "관리자ID를")}>
                    {user.id}
                  </P>
                </VerticalFlex>
              }
            >
              <P>{`${user.first_name}${
                user.last_name ? ` ${user.last_name}` : ""
              }`}</P>
            </ToolTip>
          );
        }
        if (row.customer) {
          const customer = row.customer;
          return (
            <ToolTip
              style={{
                zIndex: 1,
                padding: 10,
                backgroundColor: "white",
                width: "max-content",
                borderWidth: "1px",
                borderColor: "gray",
                borderStyle: "solid",
                borderRadius: 10,
              }}
              title={
                <VerticalFlex>
                  <P>[고객]</P>
                  <P
                    hover
                    cursor
                    onClick={() =>
                      onCopy(
                        `${customer.first_name}${
                          customer.last_name ? ` ${customer.last_name}` : ""
                        }`,
                        "이름을"
                      )
                    }
                  >{`${customer.first_name}${
                    customer.last_name ? ` ${customer.last_name}` : ""
                  }`}</P>
                  <P
                    hover
                    cursor
                    onClick={() => onCopy(customer.id, "고객ID를")}
                  >
                    {customer.id}
                  </P>
                </VerticalFlex>
              }
            >
              <P>{`${customer.first_name}${
                customer.last_name ? ` ${customer.last_name}` : ""
              }`}</P>
            </ToolTip>
          );
        }
        return "-";
      },
      index: "7",
    },
    {
      width: "100",
      text: "URL",
      justifyContent: "flex-start",
      code: "id",
      Cell: ({ cell }) => (
        <AdminCustomButton
          text="이동"
          style={style.white_border}
          onClick={() => navigate(`/article/${cell}`)}
          onMouseDown={(e) => {
            if (e.button === 1) {
              window.open(
                `${window.location.origin}/article/${cell}`,
                "_blank"
              );
            }
          }}
        />
      ),
      index: "8",
    },
  ];
  // const outputHeaderList = [
  //   {
  //     text: "No.",
  //     code: "index",
  //     Cell: ({ index }) => index,
  //     index: "0",
  //   },
  // ];
  const getOutput = (outputHeader) => {
    const output = async (data, indexes) => {
      let list;

      if (!indexes || indexes.length === 0) {
        list =
          (
            await adminRequester.getArticleStatus({
              ...extraCondition,
              ...searchCondition,
            })
          ).articles || [];
      } else {
        list = indexes.map((index) => ({
          ...data[index],
          // index: index + page * limit,
        }));
      }

      return {
        header: outputHeader,
        list: list,
        fileName: `상품_${new Date().getTime()}`,
      };
    };
    return output;
  };

  return (
    <div className={style.container}>
      <VerticalFlex>
        <FlexChild>
          <HorizontalFlex gap={10} justifyContent="flex-start">
            {views.map((view) => (
              <FlexChild width="max-content">
                <div
                  style={{
                    width: "100%",
                    textAlign: "left",
                    fontSize: 18,
                    paddingBottom: "8px",
                    fontWeight: "700",
                  }}
                  className={clsx({
                    [style.clickable]: views.length > 1 && view !== keyword,
                    [style.selected]: view === keyword && views.length > 1,
                  })}
                  onClick={() => {
                    if (views.length > 0 && view !== keyword)
                      navigator(`/admin/articleStatus/${view}`);
                  }}
                >
                  {t(view)}
                </div>
              </FlexChild>
            ))}
          </HorizontalFlex>
        </FlexChild>
        <FlexChild>
          <TableSearchCard
            callback={callback}
            index={9}
            keyword={keyword}
            reset={reset}
            setReset={setReset}
            research={research}
          />
        </FlexChild>
        <FlexChild>
          <SingleAdminTable
            keyword={keyword}
            theader={theader}
            count={count}
            mockData={data}
            initTabIndex={0}
            callback={dataCallback}
            output={outs}
            page={page}
            buttons={buttons}
            maxPage={maxPage}
            setPage={setPage}
            limit={limit}
            reset={reset}
            research={research}
          />
        </FlexChild>
      </VerticalFlex>
    </div>
  );
}

export default ArticleManagementLayout;
